export const monthyWHTTrendUIMetaData = {
  heading: 'Monthly WHT trend',
  subHeading:
    'Monthly view of withholding tax liabilities, deduction variances, and transaction volumes',
  varianceLegend: [
    { label: 'Short deduction', color: '#FFAA72' },
    { label: 'Excess deduction', color: '#FFE8D4' },
    { label: 'Records', color: '#FD5108' },
  ],
  liabilityLegend: [
    { label: 'Expense liable to WHT', color: '#FFAA72' },
    { label: 'WHT amount', color: '#FFE8D4' },
  ],
}

export const complianceStatusUIMetaData = {
  heading: 'Compliance performance overview',
  subHeading: 'Status of WHT compliances based on statutory timelines',
}

export const topContributingVendorsUIMetaData = {
  heading: 'Top WHT contributing vendors',
  legend: [
    { label: 'Expense liable to WHT', color: '#FFAA72' },
    { label: 'WHT amount', color: '#FFE8D4' },
  ],
  note: '*All values are in Millions & USD',
}

export const topPaymentCategoriesUIMetaData = {
  heading: 'Top WHT payment categories',
  legend: [
    { label: 'Expense liable to WHT', color: '#FFAA72' },
    { label: 'WHT amount', color: '#FFE8D4' },
  ],
  note: '*All values are in Millions & USD',
}

export const whtVarianceSummaryUIMetaData = {
  heading: 'WHT variance summary',
  subHeading:
    'Analysis of short deductions/excess deductions/recordsv and compliant transactions',
}

export const complianceSummaryUIMetaData = {
  heading: 'Compliance summary',
  subHeading: 'Overview of statutory compliance requirements across categories',
}

export const globalComplianceFootprintUIMetaData = {
  heading: 'Global Compliance Footprint',
  subHeading: 'Distribution of compliances across countries',
}

// ==================== Assigned Compliances Status ====================
export const COMPLIANCE_PAGE_SIZE = 10

export const complianceStatusConfig = {
  'On time': { bg: 'var(--bg-success-subtle)' },
  Delayed: { bg: 'var(--bg-yellow-light)' },
  Overdue: { bg: 'var(--bg-pink-light)' },
  Pending: { bg: 'var(--bg-light-orange)' },
  Upcoming: { bg: 'var(--bg-info-subtle)' },
}

// Shared base styles for the nested compliance accordions.
export const complianceAccordionBase = {
  boxShadow: 'none',
  borderRadius: 0,
  '&:before': { display: 'none' },
  '&:first-of-type': { borderRadius: 0 },
  '&:last-of-type': { borderRadius: 0 },
  '& .MuiAccordion-heading': {
    all: 'unset',
    display: 'block',
    borderBottom: 'none',
  },
  '&.Mui-expanded .MuiAccordion-heading': {
    borderBottom: '1px solid var(--border-subtel)',
  },
}

// Cancel / Save buttons styled to match DashboardFilter's action buttons.
export const completionDatePickerCancelSx = {
  textTransform: 'none',
  fontSize: 'var(--font-size-sm)',
  color: 'var(--forbrand-primary)',
}

export const completionDatePickerSaveSx = {
  textTransform: 'none',
  fontSize: 'var(--font-size-sm)',
  backgroundColor: 'var(--forbrand-bg-variant)',
  color: 'var(--forbrand-brand-varient)',
  boxShadow: 'none',
}
